import { motion, MotionConfig } from "framer-motion";
import React, { useState, useEffect } from "react";
import { PiWaveform, PiTextAlignLeft, PiVideoCamera } from "react-icons/pi";
import { Toasts, useToasts } from "./../shared/Toast";
import { patch, get, destroy } from "@rails/request.js";
import Loading from "./../shared/Loading";

const ProofShow = ({ proof }) => {
  return <div className="relative p-8">
    <div className="sm:text-center">
      <h2 className="text-3xl font-extrabold text-slate-900 tracking-tight sm:text-4xl">{proof.headline}</h2>
    </div>
    <div className='mt-3'>
      <MotionConfig transition={{ duration: 0.2, ease: "easeInOut" }} >
        <motion.div
          initial={{ y: 0, }}
          animate={{ y: -8, }}
          exit={{ y: 0, }}
          className="w-full overflow-hidden rounded-lg border-2 border-zinc-900 bg-white p-8 md:p-12"
        >
          <div className="mb-6 flex items-center gap-6">
            <div className="rounded-lg bg-zinc-900">
              <motion.img
                initial={{ rotate: "0deg", opacity: 0, }}
                animate={{ rotate: "3deg", opacity: 1, }}
                exit={{ rotate: "0deg", opacity: 0, }}
                src={proof.avatar}
                alt="avatar"
                className="size-24 rounded-lg border-2 border-zinc-900 bg-sspurple"
              />
            </div>
            <motion.div
              initial={{ y: 12, opacity: 0, }}
              animate={{ y: 0, opacity: 1, }}
              exit={{ y: -12, opacity: 0, }}
            >
              <span className="mb-1.5 block text-3xl font-medium">{proof.name}</span>
              <span className="text-zinc-600">
                {proof.contact_title} { proof.contact_company_name && <>– <span className="text-ssblue">{proof.contact_company_name}</span></> }
              </span>
            </motion.div>
          </div>

          <div className="text-xl">{proof.headline}</div>
          { proof.kind === 'video' && <video controls className='h-96 w-96 mx-auto object-cover rounded-md shadow-lg border border-2 border-black' src={proof.video_url} /> }
          { proof.kind === 'audio' && <video controls className='h-10 w-96 mx-auto object-cover rounded-md shadow-lg border border-2 border-black' src={proof.audio_url} /> }
          { proof.kind === 'text' && <div className='mt-1 flex flex-col text-sm text-gray-800 dark:text-gray-200'>
            <div className='prose-sm' dangerouslySetInnerHTML={{ __html: proof.body }} />
          </div> }
        </motion.div>
      </MotionConfig>
    </div>
  </div>
}

export default ProofShow;
